export const headerConstants = {
    //header name
    HEADER: 'HEADER',
    RESET_HEADER: 'RESET_HEADER',

    //haeder events types
    SET_HEADER: 'SET_HEADER',
    SET_SELECTED_HEADER: 'SET_SELECTED_HEADER',
    SET_HEADER_GREET: 'SET_HEADER_GREET'
};